import { DeleteItemService } from 'application/services/delete-item'
import { api } from 'infra/adapters/http-client-adapter'

export const handleDeleteItem = new DeleteItemService(api)
